import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { RelationShipTypeViewModel } from '../../../models/Entities/Person/RelationshipType/RelationshipTypeModels';

// store
import * as RelationshipTypesStore from '../../../redux/middleware/PersonRelationshipTypes.Middleware';

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  relationshipTypeId?: number | undefined;
}

interface ConnectedProps {
  isAdding: boolean | undefined;
  successAdding: boolean | undefined;
  failAdding: boolean | undefined;
  isUpdating: boolean | undefined;
  successUpdating: boolean | undefined;
  failUpdating: boolean | undefined;
  error: ErrorType | undefined;
  relationshipType?: RelationShipTypeViewModel;
}

interface DispatchProps {
  CreateRelationshipType: typeof RelationshipTypesStore.actionCreators.CreateRelationshipType;
  UpdateRelationshipType: typeof RelationshipTypesStore.actionCreators.UpdateRelationshipType;
  GetRelationshipTypes: typeof RelationshipTypesStore.actionCreators.GetRelationshipTypes;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isAdding: state.PersonRelationshipTypes?.isAddingNewOne,
  successAdding: state.PersonRelationshipTypes?.successAddingNewOne,
  failAdding: state.PersonRelationshipTypes?.failOnAddingNewOne,
  isUpdating: state.PersonRelationshipTypes?.isUpdatingOne,
  successUpdating: state.PersonRelationshipTypes?.successUpdatingOne,
  failUpdating: state.PersonRelationshipTypes?.failOnUpdatingOne,
  error: state.PersonRelationshipTypes?.error,
  relationshipType: state.PersonRelationshipTypes?.list.find(
    (item: RelationShipTypeViewModel) => item.id === ownProps.relationshipTypeId
  ),
  ...ownProps
});

export const mapDispatchToProps = {
  ...RelationshipTypesStore.actionCreators
};
